import addDays from '@/common/service/hooks/addDays';

export const addOneWeek = (d: Date) => addDays(d, 6);

export const addTwoWeeks = (d: Date) => addDays(d, 13);
